import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseService } from './../../_services/base.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { Observable } from 'rxjs/Rx';
declare var $: any;
declare var OpenSeadragon: any;
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../shared/baseComponent';
import { Adal5Service } from 'adal-angular5';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapRefiningComponent extends BaseComponent implements OnInit {


  overlays: any;
  public loading = true;
  currentItem = [];
  categories = [];
  mapID: number;
  sub;
  mapTitle: any;
  zoomLevel: any;

  constructor(
    private adalService: Adal5Service,
    private baseService: BaseService,
    private route: ActivatedRoute,
    private modalService: NgbModal) { super(adalService); }

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.mapID = params.processMapId;
      this.mapTitle = params.title;
    });


    this.baseService.getPointsOfInterest(this.mapID)
      // tslint:disable-next-line: comment-format
      //this.baseService.customMap()

      .then(res => {
        this.overlays = res;
        if (this.mapID === 3) {
          this.zoomLevel = .8;
        } else {
          this.zoomLevel = 0;
        }
        const viewer = OpenSeadragon({
          defaultZoomLevel: this.zoomLevel,
          minZoomLevel: 0,
          visibilityRatio: 1,
          id: 'viewer',
          prefixUrl: 'assets/images/',
          tileSources: {
            type: 'image',
            url: 'assets/maps/' + this.mapTitle + '.jpg'
          },
          overlays: this.overlays,
          showNavigator: true,
          navigatorPosition: 'BOTTOM_RIGHT',
          navigationControlAnchor: 'TOP_RIGHT',
          buildPyramid: false,
          zoomInButton: 'zoomin',
          zoomOutButton: 'zoomout',
          fullPageButton: 'fullpage',
          zoomPerClick: 2
        });
        if (this.mapID !== 3) {
          viewer.addHandler('open', function () {
            const oldBounds = viewer.viewport.getBounds();
            const newBounds = new OpenSeadragon.Rect(0, 0, 1, oldBounds.height / oldBounds.width);
            viewer.viewport.fitBounds(newBounds, true);

          });
        }

        this.loading = false;
      })
      .catch(error => console.log(error));

    /*this.overlays = [{
      "id": "188",
      "processMapId": 1,
      "categoryId": 1,
      "number": 1,
      "title": "Asphaltene Stabilizer ",
      "shortDescription": "Asphaltene laden sludge in tank bottoms, and/or the presence of unstable asphaltenes due to crude blending incompatibilities, can be reduced by using an asphaltene stabilizer – reducing and eliminating problem emulsion growth from desalters.",
      "longDescription": null,
      "x": 0.872,
      "y": 0.2565,
      "width": 0.0092,
      "height": 0.0092
    }];*/

    this.baseService.getCategories()
      .then(res => {
        this.categories = res;
      });

  }

  openPopup(content, id: any, pointOfInterest: string) {
    this.currentItem = id;
    this.modalService.open(content, { windowClass: 'poi-modal' });

    const mapTitle = this.mapTitle;
    const category = this.getCategoryName(content._parentView.context.currentItem.categoryId, content._parentView.context.categories);
    const pointOfInterestNumber = content._parentView.context.currentItem.number;
    const title = content._parentView.context.currentItem.title;
    this.customEvent('Point Of Interest', mapTitle, category, pointOfInterestNumber, title, null);
  }

  customEvent(eventType, mapTitle, category, pointOfInterestNumber, title, documentName) {
    const properties = {
      'accountId': this.adalService.userInfo.username.split('@', 1),
      'authId': this.adalService.userInfo.username,
      'ipaddr': this.adalService.userInfo.profile.ipaddr,
      'mapTitle': window.location.href.split('/', 5),
      'category': category,
      'pointOfInterestNumber': pointOfInterestNumber,
      'title': title,
      'documentName': documentName,
      'URL': window.location.href
    };

    this.logCustomEvent(eventType, properties);
  }

  getCategoryName(categoryId, categories) {
    for (let i = 0; i < categories.length; i++) {
      if (categories[i].categoryId === categoryId) {
        return categories[i].name;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/map/map.component.ts